// Priority configuration
export const PRIORITY_CONFIG = {
  Low: {
    color: '#52c41a',
    bgColor: '#f6ffed',
    borderColor: '#b7eb8f',
    icon: '🟢',
    label: 'Low'
  },
  Medium: {
    color: '#faad14',
    bgColor: '#fffbe6',
    borderColor: '#ffe58f',
    icon: '🟡',
    label: 'Medium'
  },
  High: {
    color: '#fa8c16',
    bgColor: '#fff7e6',
    borderColor: '#ffd591',
    icon: '🟠',
    label: 'High'
  },
  Critical: {
    color: '#ff4d4f',
    bgColor: '#fff2f0',
    borderColor: '#ffccc7',
    icon: '🔴',
    label: 'Critical'
  }
};

// Priority options for forms
export const PRIORITY_OPTIONS = Object.entries(PRIORITY_CONFIG).map(([value, config]) => ({
  value,
  label: config.label,
  color: config.color,
  icon: config.icon
}));

// Difficulty configuration
export const DIFFICULTY_CONFIG = {
  1: { color: '#52c41a', label: 'Very Easy' },
  2: { color: '#87d068', label: 'Easy' },
  3: { color: '#faad14', label: 'Medium' },
  4: { color: '#fa8c16', label: 'Hard' },
  5: { color: '#ff4d4f', label: 'Expert' }
};

export const DIFFICULTY_LABELS = Object.values(DIFFICULTY_CONFIG).map(config => config.label);

// Common label options
export const COMMON_LABELS = [
  { value: 'bug', label: '🐛 Bug' },
  { value: 'feature', label: '✨ Feature' },
  { value: 'backend', label: '⚙️ Backend' },
  { value: 'frontend', label: '🎨 Frontend' },
  { value: 'urgent', label: '🚨 Urgent' },
  { value: 'documentation', label: '📚 Documentation' },
  { value: 'testing', label: '🧪 Testing' },
  { value: 'review', label: '👀 Review' },
  { value: 'deployment', label: '🚀 Deployment' },
  { value: 'maintenance', label: '🔧 Maintenance' }
];

// Task status configuration
export const TASK_STATUS = {
  TODO: 'todo',
  IN_PROGRESS: 'in-progress',
  DONE: 'done'
};

// Column configuration
export const COLUMN_CONFIG = {
  [TASK_STATUS.TODO]: {
    id: TASK_STATUS.TODO,
    title: 'To Do',
    icon: '📋',
    color: '#8c8c8c'
  },
  [TASK_STATUS.IN_PROGRESS]: {
    id: TASK_STATUS.IN_PROGRESS,
    title: 'In Progress',
    icon: '⚡',
    color: '#1890ff'
  },
  [TASK_STATUS.DONE]: {
    id: TASK_STATUS.DONE,
    title: 'Done',
    icon: '✅',
    color: '#52c41a'
  }
};

// File upload configuration
export const UPLOAD_CONFIG = {
  name: 'file',
  multiple: true,
  showUploadList: false,
  customRequest: ({ file, onSuccess, onError }) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 1000);
  }
};

// Description configuration
export const DESCRIPTION_CONFIG = {
  MAX_LENGTH: 10000,
  PREVIEW_LENGTH: 120,
  PREVIEW_LINES: 2,
  EXPANDED_ROWS: 15,
  COLLAPSED_ROWS: 6
};

// Subtask configuration
export const SUBTASK_CONFIG = {
  MAX_HEIGHT: '300px',
  ANIMATION_DURATION: 200
};

// Kanban Board defaults (moved from page)
export const BOARD_COLUMNS = [
  { id: 'todo', title: 'To Do', color: '#ff4d4f', icon: '📝' },
  { id: 'in-progress', title: 'In Progress', color: '#1890ff', icon: '⚡' },
  { id: 'done', title: 'Done', color: '#52c41a', icon: '✅' },
  { id: 'review', title: 'Review', color: '#faad14', icon: '👀' }
];

export const DEFAULT_USERS = ['Ali Rezaei', 'Sara Mohammadi', 'Maryam Ahmadi', 'Reza Karimi', 'Hossein Nouri'];

export const INITIAL_TASKS = [
  {
    id: '1',
    content: 'مطالعات امکان‌سنجی و آنالیز سایت',
    description: 'بررسی پتانسیل انرژی خورشیدی منطقه، آنالیز سایه‌اندازی، مطالعات ژئوتکنیکی و تهیه گزارش کامل امکان‌سنجی برای احداث نیروگاه 5 مگاواتی',
    priority: 'Critical',
    startDate: '2024-02-01',
    endDate: '2024-02-20',
    difficulty: 4,
    labels: ['مطالعات', 'فنی', 'امکان‌سنجی', 'ژئوتکنیک'],
    assignee: 'دکتر احمدی',
    column: 'done',
    comments: [
      { id: 1, author: 'دکتر احمدی', text: 'نتایج آنالیز سایه‌اندازی مثبت اعلام شد', timestamp: '2024-02-15' }
    ],
    attachments: [
      { id: '1-1', name: 'گزارش-امکان-سنجی.pdf', size: '3.2 MB', type: 'pdf' }
    ],
    subtasks: [
      { id: '1-1', content: 'برداشت میدانی و نقشه‌برداری سایت', completed: true },
      { id: '1-2', content: 'آنالیز داده‌های تابشی خورشید', completed: true },
      { id: '1-3', content: 'مطالعات ژئوتکنیکی زمین', completed: true },
      { id: '1-4', content: 'تهیه گزارش نهایی امکان‌سنجی', completed: true }
    ],
    createdAt: '2024-01-30',
    updatedAt: '2024-02-20',
    isCompleted: true
  },
  {
    id: '2',
    content: 'طراحی سیستم فتوولتائیک',
    description: 'طراحی دقیق آرایه‌های خورشیدی، محاسبات ظرفیت، انتخاب تجهیزات بهینه و طراحی سیستم‌های مانیتورینگ و کنترل',
    priority: 'High',
    startDate: '2024-02-21',
    endDate: '2024-03-10',
    difficulty: 5,
    labels: ['طراحی', 'فتوولتائیک', 'مهندسی', 'محتوا'],
    assignee: 'مهندس کریمی',
    column: 'in-progress',
    comments: [
      { id: 1, author: 'مهندس کریمی', text: 'طراحی اولیه آرایه‌ها تکمیل شد', timestamp: '2024-02-25' }
    ],
    attachments: [
      { id: '2-1', name: 'نقشه-های-اجرایی.dwg', size: '5.1 MB', type: 'dwg' }
    ],
    subtasks: [
      { id: '2-1', content: 'محاسبه زاویه بهینه پنل‌ها', completed: true },
      { id: '2-2', content: 'انتخاب نوع پنل و اینورتر', completed: true },
      { id: '2-3', content: 'طراحی سیستم زمین و حفاظت', completed: false },
      { id: '2-4', content: 'طراحی سیستم مانیتورینگ', completed: false }
    ],
    createdAt: '2024-02-20',
    updatedAt: '2024-02-25',
    isCompleted: false,
    equipmentIds: [34, 35, 1]
  },
  {
    id: '3',
    content: 'تهیه و خرید تجهیزات',
    description: 'مناقصه و خرید پنل‌های خورشیدی، اینورترها، سازه‌های نگهدارنده، کابل‌ها و سایر تجهیزات اصلی نیروگاه',
    priority: 'High',
    startDate: '2024-03-01',
    endDate: '2024-03-25',
    difficulty: 3,
    labels: ['تدارکات', 'خرید', 'مناقصه', 'تجهیزات'],
    assignee: 'خانم رضایی',
    column: 'todo',
    comments: [],
    attachments: [],
    subtasks: [
      { id: '3-1', content: 'تهیه لیست تجهیزات مورد نیاز', completed: false },
      { id: '3-2', content: 'انتشار مناقصه خرید', completed: false },
      { id: '3-3', content: 'ارزیابی پیشنهادات تامین‌کنندگان', completed: false },
      { id: '3-4', content: 'انعقاد قرارداد خرید', completed: false }
    ],
    createdAt: '2024-02-28',
    updatedAt: '2024-02-28',
    isCompleted: false,
    equipmentIds: [39, 38]
  },
  {
    id: '4',
    content: 'آماده‌سازی سایت و فونداسیون',
    description: 'پاکسازی زمین، خاکبرداری، اجرای فونداسیون بتنی و آماده‌سازی کامل سایت برای نصب تجهیزات',
    priority: 'Medium',
    startDate: '2024-03-05',
    endDate: '2024-03-20',
    difficulty: 3,
    labels: ['ساختمانی', 'فونداسیون', 'آماده‌سازی', 'عملیات-زمینی'],
    assignee: 'مهندس محمدی',
    column: 'todo',
    comments: [],
    attachments: [],
    subtasks: [
      { id: '4-1', content: 'پاکسازی و تسطیح زمین', completed: false },
      { id: '4-2', content: 'خاکبرداری و گودبرداری', completed: false },
      { id: '4-3', content: 'اجرای فونداسیون بتنی', completed: false },
      { id: '4-4', content: 'نصب پایه‌های فلزی', completed: false }
    ],
    createdAt: '2024-03-01',
    updatedAt: '2024-03-01',
    isCompleted: false,
    equipmentIds: [42]
  },
  {
    id: '5',
    content: 'نصب پنل‌های خورشیدی',
    description: 'نصب سازه‌های نگهدارنده، قرارگیری پنل‌ها، اتصالات مکانیکی و اجرای کامل آرایه‌های خورشیدی',
    priority: 'Critical',
    startDate: '2024-03-21',
    endDate: '2024-04-10',
    difficulty: 4,
    labels: ['نصب', 'اجرایی', 'پنل', 'آرایه'],
    assignee: 'مهندس حسینی',
    column: 'todo',
    comments: [],
    attachments: [],
    subtasks: [
      { id: '5-1', content: 'نصب سازه‌های نگهدارنده', completed: false },
      { id: '5-2', content: 'قرارگیری پنل‌ها روی سازه', completed: false },
      { id: '5-3', content: 'اتصالات مکانیکی و محکم‌کاری', completed: false },
      { id: '5-4', content: 'بازرسی کیفیت نصب', completed: false }
    ],
    createdAt: '2024-03-15',
    updatedAt: '2024-03-15',
    isCompleted: false,
    equipmentIds: [2, 3, 4]
  },
  {
    id: '6',
    content: 'اتصالات الکتریکی و سیم‌کشی',
    description: 'نصب اینورترها، تابلوهای برق، سیستم زمین، کابل‌کشی و اتصالات کامل الکتریکی نیروگاه',
    priority: 'High',
    startDate: '2024-04-11',
    endDate: '2024-04-25',
    difficulty: 4,
    labels: ['الکتریکی', 'سیم‌کشی', 'اینورتر', 'تابلو'],
    assignee: 'مهندس نوروزی',
    column: 'todo',
    comments: [],
    attachments: [],
    subtasks: [
      { id: '6-1', content: 'نصب اینورتر و تجهیزات DC', completed: false },
      { id: '6-2', content: 'کابل‌کشی بین پنل‌ها و اینورتر', completed: false },
      { id: '6-3', content: 'نصب تابلوهای AC و حفاظتی', completed: false },
      { id: '6-4', content: 'اجرای سیستم ارت و زمین', completed: false }
    ],
    createdAt: '2024-04-05',
    updatedAt: '2024-04-05',
    isCompleted: false,
    equipmentIds: [44, 45]
  },
  {
    id: '7',
    content: 'راه‌اندازی و تست نهایی',
    description: 'تست عملکردی سیستم، کالیبراسیون تجهیزات، راه‌اندازی سیستم مانیتورینگ و دریافت تاییدیه نهایی',
    priority: 'Critical',
    startDate: '2024-04-26',
    endDate: '2024-05-05',
    difficulty: 5,
    labels: ['راه‌اندازی', 'تست', 'کالیبراسیون', 'پایانی'],
    assignee: 'دکتر احمدی',
    column: 'todo',
    comments: [],
    attachments: [],
    subtasks: [
      { id: '7-1', content: 'تست ایزولاسیون و ایمنی', completed: false },
      { id: '7-2', content: 'راه‌اندازی اولیه سیستم', completed: false },
      { id: '7-3', content: 'کالیبراسیون سیستم مانیتورینگ', completed: false },
      { id: '7-4', content: 'دریافت تاییدیه فنی و زیست‌محیطی', completed: false }
    ],
    createdAt: '2024-04-20',
    updatedAt: '2024-04-20',
    isCompleted: false,
    equipmentIds: [41]
  }

];


export const Equipment = [
  {
    "ID": 34,
    "Title": "Meter-LV1",
    "Url": "192.168.1.91",
    "DeviceCode": 33,
    "Serial": "4ND6CEC7",
    "Panels": null,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": "LV",
    "PhaseID": 1,
    "modelID": 12,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:42:26.797Z",
    "updateDate": "2024-10-27T11:42:26.797Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 12,
      "name": "EasyLogic PM2220",
      "category": "METER",
      "vendor_ID": 9,
      "cluster": [
        {
          "address": 2999,
          "size": 78,
          "interval": 1000
        },
        {
          "address": 3109,
          "size": 2,
          "interval": 1000
        },
        {
          "address": 3203,
          "size": 8,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 1,
      "Name": "Phase1",
      "Capacity": 2500,
      "panelNumbers": 4617,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T07:19:27.140Z",
      "UpdateDate": "2025-09-02T05:43:32.969Z"
    }
  },
  {
    "ID": 35,
    "Title": "Meter-LV2",
    "Url": "192.168.1.92",
    "DeviceCode": 34,
    "Serial": "A6UT407N",
    "Panels": null,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": "LV",
    "PhaseID": 2,
    "modelID": 12,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:50:01.899Z",
    "updateDate": "2024-10-27T11:50:01.899Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 12,
      "name": "EasyLogic PM2220",
      "category": "METER",
      "vendor_ID": 9,
      "cluster": [
        {
          "address": 2999,
          "size": 78,
          "interval": 1000
        },
        {
          "address": 3109,
          "size": 2,
          "interval": 1000
        },
        {
          "address": 3203,
          "size": 8,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 2,
      "Name": "Phase2",
      "Capacity": 2500,
      "panelNumbers": 3699,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T09:08:17.831Z",
      "UpdateDate": "2024-12-18T06:10:30.575Z"
    }
  },
  {
    "ID": 41,
    "Title": "Rain",
    "Url": "192.168.2.1",
    "DeviceCode": 38,
    "Serial": "8D293515",
    "Panels": null,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 1,
    "modelID": 32,
    "protocol": "weather",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-12-28T05:46:56.896Z",
    "updateDate": "2024-12-28T05:46:56.896Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 32,
      "name": "PTN500",
      "category": "SENSOR",
      "vendor_ID": 13,
      "cluster": [
        {
          "address": 0,
          "size": 1,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 1,
      "Name": "Phase1",
      "Capacity": 2500,
      "panelNumbers": 4617,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T07:19:27.140Z",
      "UpdateDate": "2025-09-02T05:43:32.969Z"
    }
  },
  {
    "ID": 36,
    "Title": "Relay-Hafez",
    "Url": "192.168.1.93",
    "DeviceCode": 35,
    "Serial": "EOA8C94C",
    "Panels": null,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 1,
    "modelID": 19,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:51:33.093Z",
    "updateDate": "2024-10-27T11:51:33.093Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 19,
      "name": "hafez121",
      "category": "RELAY",
      "vendor_ID": 12,
      "cluster": [
        {
          "address": 46,
          "size": 7,
          "interval": 1000
        },
        {
          "address": 100,
          "size": 104,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 1,
      "Name": "Phase1",
      "Capacity": 2500,
      "panelNumbers": 4617,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T07:19:27.140Z",
      "UpdateDate": "2025-09-02T05:43:32.969Z"
    }
  },
  {
    "ID": 37,
    "Title": "Relay-Hafez2",
    "Url": "192.168.1.93",
    "DeviceCode": 35,
    "Serial": "1C6EDFA4",
    "Panels": null,
    "SlaveID": 2,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 2,
    "modelID": 19,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:52:23.229Z",
    "updateDate": "2024-10-27T11:52:23.229Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 19,
      "name": "hafez121",
      "category": "RELAY",
      "vendor_ID": 12,
      "cluster": [
        {
          "address": 46,
          "size": 7,
          "interval": 1000
        },
        {
          "address": 100,
          "size": 104,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 2,
      "Name": "Phase2",
      "Capacity": 2500,
      "panelNumbers": 3699,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T09:08:17.831Z",
      "UpdateDate": "2024-12-18T06:10:30.575Z"
    }
  },
  {
    "ID": 42,
    "Title": "RTU-A",
    "Url": "192.168.2.1",
    "DeviceCode": 38,
    "Serial": "9ABI4AFS",
    "Panels": null,
    "SlaveID": 111,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 1,
    "modelID": 38,
    "protocol": "iec104",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-12-28T10:14:35.958Z",
    "updateDate": "2024-12-28T10:14:35.958Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 38,
      "name": "RTU-A-RTU",
      "category": "RTU",
      "vendor_ID": 15,
      "cluster": null
    },
    "phase": {
      "ID": 1,
      "Name": "Phase1",
      "Capacity": 2500,
      "panelNumbers": 4617,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T07:19:27.140Z",
      "UpdateDate": "2025-09-02T05:43:32.969Z"
    }
  },
  {
    "ID": 44,
    "Title": "RTU-B",
    "Url": "192.168.2.1",
    "DeviceCode": 38,
    "Serial": "7ACD7I07",
    "Panels": null,
    "SlaveID": 11,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 1,
    "modelID": 39,
    "protocol": "iec104",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-12-28T11:27:40.864Z",
    "updateDate": "2024-12-28T11:27:40.864Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 39,
      "name": "RTU-B-RTU",
      "category": "RTU",
      "vendor_ID": 15,
      "cluster": null
    },
    "phase": {
      "ID": 1,
      "Name": "Phase1",
      "Capacity": 2500,
      "panelNumbers": 4617,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T07:19:27.140Z",
      "UpdateDate": "2025-09-02T05:43:32.969Z"
    }
  },
  {
    "ID": 38,
    "Title": "THP303",
    "Url": "192.168.1.94",
    "DeviceCode": 37,
    "Serial": "4MTENRAD",
    "Panels": null,
    "SlaveID": 2,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 1,
    "modelID": 20,
    "protocol": "modbus",
    "response_timeout": 1000,
    "connection_timeout": 1100,
    "CreationDate": "2024-10-27T11:53:48.861Z",
    "updateDate": "2024-11-23T05:18:18.658Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 20,
      "name": "THP303",
      "category": "SENSOR",
      "vendor_ID": 13,
      "cluster": [
        {
          "address": 0,
          "size": 3,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 1,
      "Name": "Phase1",
      "Capacity": 2500,
      "panelNumbers": 4617,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T07:19:27.140Z",
      "UpdateDate": "2025-09-02T05:43:32.969Z"
    }
  },
  {
    "ID": 1,
    "Title": "Tr1-inv1",
    "Url": "192.168.1.101",
    "DeviceCode": 1,
    "Serial": "51E8112F",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 1,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T09:07:05.582Z",
    "updateDate": "2024-10-29T08:07:48.466Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 1,
      "Name": "Phase1",
      "Capacity": 2500,
      "panelNumbers": 4617,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T07:19:27.140Z",
      "UpdateDate": "2025-09-02T05:43:32.969Z"
    }
  },
  {
    "ID": 2,
    "Title": "Tr1-inv2",
    "Url": "192.168.1.102",
    "DeviceCode": 2,
    "Serial": "55FF5642",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 1,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T09:19:22.715Z",
    "updateDate": "2024-10-29T08:07:53.086Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 1,
      "Name": "Phase1",
      "Capacity": 2500,
      "panelNumbers": 4617,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T07:19:27.140Z",
      "UpdateDate": "2025-09-02T05:43:32.969Z"
    }
  },
  {
    "ID": 3,
    "Title": "Tr1-inv3",
    "Url": "192.168.1.103",
    "DeviceCode": 3,
    "Serial": "4F74FENO",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 1,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T09:33:16.265Z",
    "updateDate": "2024-10-29T08:07:58.796Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 1,
      "Name": "Phase1",
      "Capacity": 2500,
      "panelNumbers": 4617,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T07:19:27.140Z",
      "UpdateDate": "2025-09-02T05:43:32.969Z"
    }
  },
  {
    "ID": 4,
    "Title": "Tr1-inv4",
    "Url": "192.168.1.104",
    "DeviceCode": 4,
    "Serial": "FD6B9C06",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 1,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T10:12:46.074Z",
    "updateDate": "2024-10-29T08:08:02.833Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 1,
      "Name": "Phase1",
      "Capacity": 2500,
      "panelNumbers": 4617,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T07:19:27.140Z",
      "UpdateDate": "2025-09-02T05:43:32.969Z"
    }
  },
  {
    "ID": 5,
    "Title": "Tr1-inv5",
    "Url": "192.168.1.105",
    "DeviceCode": 5,
    "Serial": "F9FSEBFU",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 1,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T10:28:20.464Z",
    "updateDate": "2024-10-29T08:08:07.017Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 1,
      "Name": "Phase1",
      "Capacity": 2500,
      "panelNumbers": 4617,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T07:19:27.140Z",
      "UpdateDate": "2025-09-02T05:43:32.969Z"
    }
  },
  {
    "ID": 6,
    "Title": "Tr1-inv6",
    "Url": "192.168.1.106",
    "DeviceCode": 6,
    "Serial": "C595A3AB",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 1,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T10:32:15.727Z",
    "updateDate": "2024-10-29T08:08:12.925Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 1,
      "Name": "Phase1",
      "Capacity": 2500,
      "panelNumbers": 4617,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T07:19:27.140Z",
      "UpdateDate": "2025-09-02T05:43:32.969Z"
    }
  },
  {
    "ID": 9,
    "Title": "Tr1-inv7",
    "Url": "192.168.1.107",
    "DeviceCode": 8,
    "Serial": "B2VUSD4N",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 1,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T10:51:49.322Z",
    "updateDate": "2024-10-29T08:08:17.360Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 1,
      "Name": "Phase1",
      "Capacity": 2500,
      "panelNumbers": 4617,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T07:19:27.140Z",
      "UpdateDate": "2025-09-02T05:43:32.969Z"
    }
  },
  {
    "ID": 7,
    "Title": "Tr1-inv8",
    "Url": "192.168.1.108",
    "DeviceCode": 7,
    "Serial": "1BBC2F6C",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 1,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T10:38:33.531Z",
    "updateDate": "2024-10-29T08:08:20.879Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 1,
      "Name": "Phase1",
      "Capacity": 2500,
      "panelNumbers": 4617,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T07:19:27.140Z",
      "UpdateDate": "2025-09-02T05:43:32.969Z"
    }
  },
  {
    "ID": 10,
    "Title": "Tr1-inv9",
    "Url": "192.168.1.109",
    "DeviceCode": 9,
    "Serial": "F2EA6FFI",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 1,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:04:17.704Z",
    "updateDate": "2024-10-29T08:08:24.547Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 1,
      "Name": "Phase1",
      "Capacity": 2500,
      "panelNumbers": 4617,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T07:19:27.140Z",
      "UpdateDate": "2025-09-02T05:43:32.969Z"
    }
  },
  {
    "ID": 11,
    "Title": "Tr1-inv10",
    "Url": "192.168.1.110",
    "DeviceCode": 10,
    "Serial": "98716E8A",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 1,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:04:54.456Z",
    "updateDate": "2024-10-29T08:08:28.589Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 1,
      "Name": "Phase1",
      "Capacity": 2500,
      "panelNumbers": 4617,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T07:19:27.140Z",
      "UpdateDate": "2025-09-02T05:43:32.969Z"
    }
  },
  {
    "ID": 12,
    "Title": "Tr1-inv11",
    "Url": "192.168.1.111",
    "DeviceCode": 11,
    "Serial": "3CDF92CF",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 1,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:07:04.861Z",
    "updateDate": "2024-10-29T08:08:33.055Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 1,
      "Name": "Phase1",
      "Capacity": 2500,
      "panelNumbers": 4617,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T07:19:27.140Z",
      "UpdateDate": "2025-09-02T05:43:32.969Z"
    }
  },
  {
    "ID": 13,
    "Title": "Tr1-inv12",
    "Url": "192.168.1.112",
    "DeviceCode": 12,
    "Serial": "168CO5FU",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 1,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:07:29.409Z",
    "updateDate": "2024-10-29T08:08:39.948Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 1,
      "Name": "Phase1",
      "Capacity": 2500,
      "panelNumbers": 4617,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T07:19:27.140Z",
      "UpdateDate": "2025-09-02T05:43:32.969Z"
    }
  },
  {
    "ID": 14,
    "Title": "Tr1-inv13",
    "Url": "192.168.1.113",
    "DeviceCode": 13,
    "Serial": "003EAU9N",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 1,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:08:13.173Z",
    "updateDate": "2024-10-29T08:08:45.524Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 1,
      "Name": "Phase1",
      "Capacity": 2500,
      "panelNumbers": 4617,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T07:19:27.140Z",
      "UpdateDate": "2025-09-02T05:43:32.969Z"
    }
  },
  {
    "ID": 15,
    "Title": "Tr1-inv14",
    "Url": "192.168.1.114",
    "DeviceCode": 14,
    "Serial": "IBCN20SI",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 1,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:26:36.140Z",
    "updateDate": "2024-10-29T08:08:50.677Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 1,
      "Name": "Phase1",
      "Capacity": 2500,
      "panelNumbers": 4617,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T07:19:27.140Z",
      "UpdateDate": "2025-09-02T05:43:32.969Z"
    }
  },
  {
    "ID": 16,
    "Title": "Tr1-inv15",
    "Url": "192.168.1.115",
    "DeviceCode": 15,
    "Serial": "50203IFA",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 1,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:26:58.295Z",
    "updateDate": "2024-10-29T08:08:56.137Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 1,
      "Name": "Phase1",
      "Capacity": 2500,
      "panelNumbers": 4617,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T07:19:27.140Z",
      "UpdateDate": "2025-09-02T05:43:32.969Z"
    }
  },
  {
    "ID": 17,
    "Title": "Tr1-inv16",
    "Url": "192.168.1.116",
    "DeviceCode": 16,
    "Serial": "6SNT1FFC",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 1,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:27:23.261Z",
    "updateDate": "2024-10-29T08:09:01.966Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 1,
      "Name": "Phase1",
      "Capacity": 2500,
      "panelNumbers": 4617,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T07:19:27.140Z",
      "UpdateDate": "2025-09-02T05:43:32.969Z"
    }
  },
  {
    "ID": 18,
    "Title": "Tr2-inv1",
    "Url": "192.168.1.121",
    "DeviceCode": 17,
    "Serial": "50A0B6G0",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 2,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:29:01.717Z",
    "updateDate": "2024-10-29T08:09:05.772Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 2,
      "Name": "Phase2",
      "Capacity": 2500,
      "panelNumbers": 3699,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T09:08:17.831Z",
      "UpdateDate": "2024-12-18T06:10:30.575Z"
    }
  },
  {
    "ID": 19,
    "Title": "Tr2-inv2",
    "Url": "192.168.1.122",
    "DeviceCode": 18,
    "Serial": "1E62A79F",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 2,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:29:38.692Z",
    "updateDate": "2024-10-29T08:09:09.722Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 2,
      "Name": "Phase2",
      "Capacity": 2500,
      "panelNumbers": 3699,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T09:08:17.831Z",
      "UpdateDate": "2024-12-18T06:10:30.575Z"
    }
  },
  {
    "ID": 20,
    "Title": "Tr2-inv3",
    "Url": "192.168.1.123",
    "DeviceCode": 19,
    "Serial": "B5B0E966",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 2,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:30:06.302Z",
    "updateDate": "2024-10-29T08:09:13.865Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 2,
      "Name": "Phase2",
      "Capacity": 2500,
      "panelNumbers": 3699,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T09:08:17.831Z",
      "UpdateDate": "2024-12-18T06:10:30.575Z"
    }
  },
  {
    "ID": 21,
    "Title": "Tr2-inv4",
    "Url": "192.168.1.124",
    "DeviceCode": 20,
    "Serial": "AT0FUT13",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 2,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:30:37.125Z",
    "updateDate": "2024-10-29T08:09:17.498Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 2,
      "Name": "Phase2",
      "Capacity": 2500,
      "panelNumbers": 3699,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T09:08:17.831Z",
      "UpdateDate": "2024-12-18T06:10:30.575Z"
    }
  },
  {
    "ID": 22,
    "Title": "Tr2-inv5",
    "Url": "192.168.1.125",
    "DeviceCode": 21,
    "Serial": "BSOTS30L",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 2,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:31:34.146Z",
    "updateDate": "2024-10-29T08:09:23.949Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 2,
      "Name": "Phase2",
      "Capacity": 2500,
      "panelNumbers": 3699,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T09:08:17.831Z",
      "UpdateDate": "2024-12-18T06:10:30.575Z"
    }
  },
  {
    "ID": 23,
    "Title": "Tr2-inv6",
    "Url": "192.168.1.126",
    "DeviceCode": 22,
    "Serial": "25C4L0CS",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 2,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:32:24.629Z",
    "updateDate": "2024-10-29T08:09:30.121Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 2,
      "Name": "Phase2",
      "Capacity": 2500,
      "panelNumbers": 3699,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T09:08:17.831Z",
      "UpdateDate": "2024-12-18T06:10:30.575Z"
    }
  },
  {
    "ID": 24,
    "Title": "Tr2-inv7",
    "Url": "192.168.1.127",
    "DeviceCode": 23,
    "Serial": "3IB5EEF8",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 2,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:32:49.663Z",
    "updateDate": "2024-10-29T08:09:34.580Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 2,
      "Name": "Phase2",
      "Capacity": 2500,
      "panelNumbers": 3699,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T09:08:17.831Z",
      "UpdateDate": "2024-12-18T06:10:30.575Z"
    }
  },
  {
    "ID": 25,
    "Title": "Tr2-inv8",
    "Url": "192.168.1.128",
    "DeviceCode": 24,
    "Serial": "81F16F0U",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 2,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:33:32.206Z",
    "updateDate": "2024-10-29T08:09:38.534Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 2,
      "Name": "Phase2",
      "Capacity": 2500,
      "panelNumbers": 3699,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T09:08:17.831Z",
      "UpdateDate": "2024-12-18T06:10:30.575Z"
    }
  },
  {
    "ID": 26,
    "Title": "Tr2-inv9",
    "Url": "192.168.1.129",
    "DeviceCode": 25,
    "Serial": "SB4EUB6F",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 2,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:34:13.988Z",
    "updateDate": "2024-10-29T08:09:43.205Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 2,
      "Name": "Phase2",
      "Capacity": 2500,
      "panelNumbers": 3699,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T09:08:17.831Z",
      "UpdateDate": "2024-12-18T06:10:30.575Z"
    }
  },
  {
    "ID": 27,
    "Title": "Tr2-inv10",
    "Url": "192.168.1.130",
    "DeviceCode": 26,
    "Serial": "F478A306",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 2,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:34:42.094Z",
    "updateDate": "2024-10-29T08:09:49.351Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 2,
      "Name": "Phase2",
      "Capacity": 2500,
      "panelNumbers": 3699,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T09:08:17.831Z",
      "UpdateDate": "2024-12-18T06:10:30.575Z"
    }
  },
  {
    "ID": 28,
    "Title": "Tr2-inv11",
    "Url": "192.168.1.131",
    "DeviceCode": 27,
    "Serial": "F3665774",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 2,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:36:23.495Z",
    "updateDate": "2024-10-29T08:09:52.606Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 2,
      "Name": "Phase2",
      "Capacity": 2500,
      "panelNumbers": 3699,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T09:08:17.831Z",
      "UpdateDate": "2024-12-18T06:10:30.575Z"
    }
  },
  {
    "ID": 29,
    "Title": "Tr2-inv12",
    "Url": "192.168.1.132",
    "DeviceCode": 28,
    "Serial": "EF0EG2OU",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 2,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:36:45.292Z",
    "updateDate": "2024-10-29T08:09:59.111Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 2,
      "Name": "Phase2",
      "Capacity": 2500,
      "panelNumbers": 3699,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T09:08:17.831Z",
      "UpdateDate": "2024-12-18T06:10:30.575Z"
    }
  },
  {
    "ID": 30,
    "Title": "Tr2-inv13",
    "Url": "192.168.1.133",
    "DeviceCode": 29,
    "Serial": "16371FC5",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 2,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:37:06.892Z",
    "updateDate": "2024-10-29T08:10:03.094Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 2,
      "Name": "Phase2",
      "Capacity": 2500,
      "panelNumbers": 3699,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T09:08:17.831Z",
      "UpdateDate": "2024-12-18T06:10:30.575Z"
    }
  },
  {
    "ID": 31,
    "Title": "Tr2-inv14",
    "Url": "192.168.1.134",
    "DeviceCode": 30,
    "Serial": "5ISUGIOM",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 2,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:37:29.941Z",
    "updateDate": "2024-10-29T08:10:06.840Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 2,
      "Name": "Phase2",
      "Capacity": 2500,
      "panelNumbers": 3699,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T09:08:17.831Z",
      "UpdateDate": "2024-12-18T06:10:30.575Z"
    }
  },
  {
    "ID": 32,
    "Title": "Tr2-inv15",
    "Url": "192.168.1.135",
    "DeviceCode": 31,
    "Serial": "3FE149D3",
    "Panels": 10,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 2,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:37:57.385Z",
    "updateDate": "2024-10-29T08:10:10.222Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 2,
      "Name": "Phase2",
      "Capacity": 2500,
      "panelNumbers": 3699,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T09:08:17.831Z",
      "UpdateDate": "2024-12-18T06:10:30.575Z"
    }
  },
  {
    "ID": 33,
    "Title": "Tr2-inv16",
    "Url": "192.168.1.136",
    "DeviceCode": 32,
    "Serial": "AE7FOEEB",
    "Panels": 9,
    "SlaveID": 1,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 2,
    "modelID": 27,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T11:38:32.117Z",
    "updateDate": "2024-10-29T08:10:15.190Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 27,
      "name": "Blueplanet 165 TL3",
      "category": "INVERTER",
      "vendor_ID": 3,
      "cluster": [
        {
          "address": 40072,
          "size": 38,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 2,
      "Name": "Phase2",
      "Capacity": 2500,
      "panelNumbers": 3699,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T09:08:17.831Z",
      "UpdateDate": "2024-12-18T06:10:30.575Z"
    }
  },
  {
    "ID": 39,
    "Title": "weather",
    "Url": "192.168.1.254",
    "DeviceCode": 36,
    "Serial": "DBAOL550",
    "Panels": null,
    "SlaveID": 1,
    "Port": 5000,
    "subCategory": null,
    "PhaseID": 1,
    "modelID": 16,
    "protocol": "weather",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-10-27T12:04:38.705Z",
    "updateDate": "2024-10-27T12:04:38.705Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 16,
      "name": "Farscada Weather Sensor v2",
      "category": "SENSOR",
      "vendor_ID": 11,
      "cluster": [
        {
          "address": 1,
          "size": 6,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 1,
      "Name": "Phase1",
      "Capacity": 2500,
      "panelNumbers": 4617,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T07:19:27.140Z",
      "UpdateDate": "2025-09-02T05:43:32.969Z"
    }
  },
  {
    "ID": 45,
    "Title": "Weather 2",
    "Url": "192.168.2.1",
    "DeviceCode": 38,
    "Serial": "0RB04BA2",
    "Panels": null,
    "SlaveID": 1213,
    "Port": 502,
    "subCategory": null,
    "PhaseID": 1,
    "modelID": 21,
    "protocol": "modbus",
    "response_timeout": 70,
    "connection_timeout": 1000,
    "CreationDate": "2024-12-28T12:44:53.587Z",
    "updateDate": "2024-12-28T12:44:53.587Z",
    "channel": null,
    "DeviceID": null,
    "model": {
      "ID": 21,
      "name": "Data Logger DL Series",
      "category": "SENSOR",
      "vendor_ID": 13,
      "cluster": [
        {
          "address": 0,
          "size": 8,
          "interval": 1000
        }
      ]
    },
    "phase": {
      "ID": 1,
      "Name": "Phase1",
      "Capacity": 2500,
      "panelNumbers": 4617,
      "panelArea": 2.5764,
      "CreationDate": "2024-10-27T07:19:27.140Z",
      "UpdateDate": "2025-09-02T05:43:32.969Z"
    }
  }
]

export const ALARM_DATA = [
  {
    "ID": 3,
    "no": 3,
    "Display": "Fault",
    "Description": "Fault",
    "Action": null,
    "Pers": null,
    "modelTitle": [
      "Growatt 3 OR 1 Phase",
      "Growatt MAX Series"
    ]
  },
  {
    "ID": 7,
    "no": 60,
    "Display": "Normal Status",
    "Description": null,
    "Action": null,
    "Pers": null,
    "modelTitle": [
      "SMA STP"
    ]
  },
  {
    "ID": 8,
    "no": 0,
    "Display": "Fault",
    "Description": "Energy supply of the processor printed circuit board is defective.",
    "Action": null,
    "Pers": null,
    "modelTitle": [
      "SMA STP",
      "SMA STP Series-60"
    ]
  },
  {
    "ID": 137,
    "no": 58,
    "Display": "Control board overtemp.",
    "Description": "The temperature inside the device was too high. The device shuts down to avoid hardware damage.",
    "Action": "How high is the device output? Fan on? Heat sink covered? The ambient temperature may be too high. (Use active cooling)",
    "Pers": "E",
    "modelTitle": [
      "Kaco blueplanet TL",
      "Blueplanet 165 TL3"
    ]
  }
];


export const NEW_ALARM = [
  {
    ID: 1,
    Type: 'STATUS',
    Alarm_NAME: 'Abnormal event - Atr3-inv16',
    Status: 2,
    Display: 'Insufficient generator voltage / insufficient battery voltage',
    Description: 'Abnormal event for Atr3-inv16'

  }
  ,

  {
    ID: 2,
    Type: 'DISCONNECTED',
    Alarm_NAME: 'Disconnect - Atr3-inv8',
    Status: '-',
    Display: '',
    Description: 'Disconnect alarm for Atr3-inv8'

  },

  {
    ID: 3,
    Type: 'STATUS',
    Alarm_NAME: 'Abnormal event - Atr3-inv20',
    Status: 2,
    Display: 'Insufficient generator voltage / insufficient battery voltage',
    Description: 'Abnormal event for Atr3-inv20'

  },
  {
    ID: 4,
    Type: 'STATUS',
    Alarm_NAME: 'Abnormal event - Atr3-inv17',
    Status: 2,
    Display: 'Insufficient generator voltage / insufficient battery voltage',
    Description: 'Abnormal event for Atr3-inv17'

  },
  {
    ID: 5,
    Type: 'STATUS',
    Alarm_NAME: 'Abnormal event - Atr3-inv10',
    Status: 2,
    Display: 'Insufficient generator voltage / insufficient battery voltage',
    Description: 'Abnormal event for Atr3-inv10'

  }
]

export const initialEquipmentsInventory = [
  {
    id: 'EQ-2001',
    name: 'کابل فشار قوی ۲۰ کیلوولت',
    type: 'کابل برق',
    location: 'انبار تجهیزات فشار قوی',
    status: 'Available',
    value: 4500,
    description: 'کابل مسی ۲۰ کیلوولت با عایق XLPE',
    lastMaintenance: '2025-09-10',
    nextMaintenance: '2026-03-10'
  },
  {
    id: 'EQ-2002',
    name: 'سوکت کابل ۲۰ کیلوولت',
    type: 'اتصالات کابل',
    location: 'انبار تجهیزات فشار قوی',
    status: 'In Use',
    value: 1200,
    description: 'سوکت انتهایی برای کابل های فشار قوی',
    lastMaintenance: '2025-10-05',
    nextMaintenance: '2026-04-05'
  },
  {
    id: 'EQ-2003',
    name: 'ترانسفورماتور جریان',
    type: 'تجهیزات اندازه گیری',
    location: 'پست برق اصلی',
    status: 'Available',
    value: 8500,
    description: 'ترانسفورماتور جریان برای سیستم های حفاظتی',
    lastMaintenance: '2025-08-15',
    nextMaintenance: '2026-02-15'
  },
  {
    id: 'EQ-2004',
    name: 'کلید قطع بار',
    type: 'تجهیزات قطع و وصل',
    location: 'اتاق کنترل',
    status: 'Maintenance',
    value: 3200,
    description: 'کلید قطع بار تحت ولتاژ ۱۱ کیلوولت',
    lastMaintenance: '2025-11-01',
    nextMaintenance: '2026-05-01'
  },
  {
    id: 'EQ-2005',
    name: 'بوشینگ ترانسفورماتور',
    type: 'تجهیزات عایقی',
    location: 'انبار تجهیزات ترانسفورماتور',
    status: 'Available',
    value: 2800,
    description: 'بوشینگ پورسلین برای ترانسفورماتورهای قدرت',
    lastMaintenance: '2025-09-20',
    nextMaintenance: '2026-03-20'
  },
  {
    id: 'EQ-2006',
    name: 'رله حفاظتی دیجیتال',
    type: 'تجهیزات حفاظتی',
    location: 'پانل کنترل',
    status: 'In Use',
    value: 5500,
    description: 'رله حفاظتی دیجیتال با قابلیت پایش آنلاین',
    lastMaintenance: '2025-10-12',
    nextMaintenance: '2026-04-12'
  },
  {
    id: 'EQ-2007',
    name: 'باتری UPS',
    type: 'منبع تغذیه',
    location: 'اتاق باتری',
    status: 'Available',
    value: 1800,
    description: 'باتری سیلد اسید برای سیستم UPS',
    lastMaintenance: '2025-08-25',
    nextMaintenance: '2026-02-25'
  },
  {
    id: 'EQ-2008',
    name: 'کنتاکتور فشار قوی',
    type: 'تجهیزات قطع و وصل',
    location: 'انبار تجهیزات فشار قوی',
    status: 'Available',
    value: 4200,
    description: 'کنتاکتور ۱۱ کیلوولت برای موتورهای بزرگ',
    lastMaintenance: '2025-09-30',
    nextMaintenance: '2026-03-30'
  },
  {
    id: 'EQ-2009',
    name: 'ترمینال باکس',
    type: 'اتصالات',
    location: 'انبار عمومی',
    status: 'In Use',
    value: 950,
    description: 'جعبه ترمینال ضد انفجار برای محیط های خطرناک',
    lastMaintenance: '2025-10-08',
    nextMaintenance: '2026-04-08'
  },
  {
    id: 'EQ-2010',
    name: 'فیوز فشار قوی',
    type: 'تجهیزات حفاظتی',
    location: 'انبار تجهیزات فشار قوی',
    status: 'Available',
    value: 1500,
    description: 'فیوز حفاظتی ۳۳ کیلوولت با قابلیت قطع بالا',
    lastMaintenance: '2025-09-05',
    nextMaintenance: '2026-03-05'
  }
];